<template>
  <b-modal 
    ref="modalEstoque" 
    id="modal-configuracao-estoque" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="xl"
    @shown="onModalShown"
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
         style="background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-cubes text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Configurações de Estoque</h5>
        <small class="text-white opacity-75">Defina os centros de estoque e parâmetros de controle</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <!-- Corpo do Modal -->
    <div class="p-4" style="max-height: 70vh; overflow-y: auto;">
      
      <!-- Grupo Centros de Estoque -->
      <div class="modal-section-title mb-3">
        <i class="fa fa-warehouse mr-2 text-primary"></i> Centros de Estoque
      </div>
      <b-row>
        <b-col md="4">
          <b-form-group label="Centro de Estoque Faturamento" label-for="cod-centroestoque">
            <centro-estoque-drop-down 
              v-model="registro.COD_CENTROESTOQUE"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Estoque da NFe" label-for="id-estoque-nfe">
            <centro-estoque-drop-down 
              v-model="registro.ID_ESTOQUE_NFE"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Estoque Destino Produção" label-for="estoque-producao">
            <centro-estoque-drop-down 
              v-model="registro.ESTOQUE_PRODUCAO_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Estoque Compra de Gado" label-for="centro-compra-gado">
            <centro-estoque-drop-down 
              v-model="registro.CENTRO_COMPRA_GADO_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Estoque do Almoxarifado" label-for="centro-estoque-almoxarifado">
            <centro-estoque-drop-down 
              v-model="registro.CENTRO_ESTOQUE_ALMOXARIFADO_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Estoque Expedição" label-for="estoque-expedicao">
            <centro-estoque-drop-down 
              v-model="registro.ESTOQUE_EXPEDICAO_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Estoque Inventário Etiqueta" label-for="centro-estoque-etiqueta-inv">
            <centro-estoque-drop-down 
              v-model="registro.CENTRO_ESTOQUE_ETIQUETA_INV"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Estoque de Entrada Produção" label-for="centro-estoque-producao">
            <centro-estoque-drop-down 
              v-model="registro.CENTRO_ESTOQUE_PRODUCAO_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Estoque das Bandas do Abate" label-for="centro-estoque-abate">
            <centro-estoque-drop-down 
              v-model="registro.CENTRO_ESTOQUE_ABATE_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo Controle de Estoque -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-cog mr-2 text-success"></i> Controle de Estoque
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group label="Volumes" label-for="op-estoque-etiquetado">
            <b-form-select v-model="registro.OP_ESTOQUE_ETIQUETADO">
              <option value="0">0 - Controla por Compras e Vendas</option>
              <option value="1">1 - Controla por Etiquetas</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Controlar por Estoque Estimado para Produtos com Mapa de Beneficiamento" label-for="op-estoque-estimado">
            <b-form-select v-model="registro.OP_ESTOQUE_ESTIMADO">
              <option value="0">0 - Não</option>
              <option value="1">1 - Sim</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Permitir almoxarifado operar com estoque negativo" label-for="op-permitir-almoxa-sem-estoque">
            <b-form-select v-model="registro.OP_PERMITIR_ALMOXA_SEM_ESTOQUE">
              <option value="0">0 - Não</option>
              <option value="1">1 - Sim</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Pedido Estoque Livre APP" label-for="op-permite-pedido-estoque-livre">
            <b-form-select v-model="registro.OP_PERMITE_PEDIDO_ESTOQUE_LIVRE">
              <option value="0">0 - Não</option>
              <option value="1">1 - Sim</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Dias Alerta Vencimento na Expedição" label-for="dias-alerta-vencimento">
            <b-form-input
              v-model.number="registro.DIAS_ALERTA_VENCIMENTO"
              type="number"
              min="0"
              max="365"
            />
          </b-form-group>
        </b-col>
      </b-row>

    </div>

    <!-- Rodapé Premium -->
    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
        CANCELAR
      </b-button>
      <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar()">
        <i class="fa fa-check-circle mr-1"></i> SALVAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import CentroEstoqueDropDown from '../views/componentes/dropdown/CentroEstoqueDropDown.vue'

export default {
  name: 'ModalConfiguracaoEstoque',
  components: {
    CentroEstoqueDropDown
  },
  data() {
    return {
      registro: {
        SEQUENCIA: 1,
        // Centros de Estoque
        COD_CENTROESTOQUE: null,
        ID_ESTOQUE_NFE: null,
        ESTOQUE_PRODUCAO_ID: null,
        CENTRO_COMPRA_GADO_ID: null,
        CENTRO_ESTOQUE_ALMOXARIFADO_ID: null,
        ESTOQUE_EXPEDICAO_ID: null,
        CENTRO_ESTOQUE_ETIQUETA_INV: null,
        CENTRO_ESTOQUE_PRODUCAO_ID: null,
        CENTRO_ESTOQUE_ABATE_ID: null,
        // Controle de Estoque
        OP_ESTOQUE_ETIQUETADO: '0',
        OP_ESTOQUE_ESTIMADO: '0',
        OP_PERMITIR_ALMOXA_SEM_ESTOQUE: '0',
        OP_PERMITE_PEDIDO_ESTOQUE_LIVRE: '0',
        DIAS_ALERTA_VENCIMENTO: 0
      }
    }
  },
  methods: {
    abrir() {
      this.$refs.modalEstoque.show()
    },
    fechar() {
      this.$refs.modalEstoque.hide()
    },
    async carregarDados() {
      try {
        const { data } = await this.$http.get('/api/protected/parametro/getDados')
        if (data && data.length > 0) {
          this.registro = {
            ...this.registro,
            ...data[0],
            // Garantir valores default para os campos de controle
            OP_ESTOQUE_ETIQUETADO: data[0].OP_ESTOQUE_ETIQUETADO || '0',
            OP_ESTOQUE_ESTIMADO: data[0].OP_ESTOQUE_ESTIMADO || '0',
            OP_PERMITIR_ALMOXA_SEM_ESTOQUE: data[0].OP_PERMITIR_ALMOXA_SEM_ESTOQUE || '0',
            OP_PERMITE_PEDIDO_ESTOQUE_LIVRE: data[0].OP_PERMITE_PEDIDO_ESTOQUE_LIVRE || '0',
            DIAS_ALERTA_VENCIMENTO: data[0].DIAS_ALERTA_VENCIMENTO || 0
          }
        }
      } catch (err) {
        console.error('Erro ao carregar configurações:', err)
        this.$root.$bvToast.toast('Erro ao carregar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    async salvar() {
      try {
        const { data } = await this.$http.post('/api/protected/parametro/update', {
          registro: this.registro
        })
        
        this.$root.$bvToast.toast(data.mensagem || 'Configurações salvas com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })
        
        this.fechar()
      } catch (err) {
        console.error('Erro ao salvar configurações:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao salvar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    onModalShown() {
      this.carregarDados()
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.opacity-75 {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/modals/ModalConfiguracaoEstoque.vue